<template>
  <v-container
      fluid
  >
    <v-card class="pa-5" tile>
      <v-form
        autocomplete="off"
        @submit="function(e){saveItem();e.preventDefault()}"
      >

        <v-row class="mt-n5">
          <v-col cols="2" sm="2" class="px-0">
            {{ $t('Date of visit') }}
          </v-col>
          <v-col cols="3" sm="3" class="px-0">
            {{ $t('From') }}
            <date-picker-field
                v-model="search.from_date"
                :error-messages="errors.from_date"
                :label="undefined"
                clearable
                tabindex="10"
            >
            </date-picker-field>
          </v-col>
          <v-col cols="3" sm="3" class="px-0">
            {{ $t('To') }}
            <date-picker-field
                v-model="search.to_date"
                :error-messages="errors.to_date"
                :label="undefined"
                clearable
                tabindex="15"
            >
            </date-picker-field>
          </v-col>
        </v-row>

        <v-row>
            <v-col cols="2" sm="2" class="px-0">
                {{ $t('Action') }}
            </v-col>
            <v-col cols="2" sm="2" class="px-0">
                <v-btn @click="resetForm">{{ $t('Clear form') }}</v-btn>
                &nbsp;
                <v-btn @click="exportXls">{{ $t('Export XLS') }}</v-btn>
            </v-col>
        </v-row>

      </v-form>

    </v-card>
  </v-container>

</template>

<script>
import ApiService from '@/services/api.service'
import DatePickerField from '@/components/DatePickerField'
// import {fetchMultipleLists} from '@/lib/helpers'

export default {
  components: {
    DatePickerField,
  },
  data: () => ({
    errors: {},
    search: {},
  }),
  watch: {
    '$i18n.locale': function () {
        this.fetchTranslatables()
    },
  },
  methods: {
    resetForm() {
      this.search = {
        psychologists: null,
        appointment_locations: null,
        from_date: null,
        to_date: null,
        treatment_interactions: null,
        statuses: null,
      }
    },
    getItem() {
      const item = this.search
      return item
    },
    exportXls() {
      this.errors = {}
      this.$store.dispatch('session/showLoader')
     
      ApiService.download(`/exports/evaluation/xls`, { filter: this.search }).then(response => {
        this.openFile(response.data, response.filename)
      }).catch(errors => {
        this.errors = errors
        console.log(errors)
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
    openFile(blob, filename) {
        const data = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = data;
        link.download=filename;
        link.click();
        setTimeout(function(){
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
        }, 100);
    },    
    fetchTranslatables() {
        // fetchMultipleLists(this, {
        //     // These must be listed in created() as well
        //     main_status: 'statuses',
        // }, '/master-files/get-multiple-lists', 'master_file_type_tags')
    },
  },
  created() {
    this.resetForm();
    this.$store.dispatch('session/title', 'Reports - Evaluation')
    // fetchMultipleLists(this, {
    //     // Non-translatable

    //     // Translatable; must be listed in fetchTranslatables() as well
    //     main_status: 'statuses',
    // }, '/master-files/get-multiple-lists', 'master_file_type_tags')
  },
}
</script>

<style scoped>

</style>
